/*
 * Copyright (c) 2021, 2022 Tropyc Stoic (38c316a1b8d7188d059c273d892b723b)
 *
 * Permission to use, copy, modify, and distribute this software for any
 * purpose with or without fee is hereby granted, provided that the above
 * copyright notice and this permission notice appear in all copies.
 *
 * THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
 * WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
 * MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
 * ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
 * WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
 * ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
 * OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
 */
import { useState } from 'react';
import reBurnProtocol from './artifacts/contracts/reBurnProtocol.sol/reBurnProtocol.json'
import { ethers } from 'ethers';

const currentversion = 3; //TODO: update this each release!

export default function VersionCheck(props) {
    const {web3, seedAddress} = props;
    const current = window.location.origin + window.location.pathname;
    const [loading, setLoading] = useState(false);
    const [recommendedUri, setRecommendedUri] = useState(null);
    const [isCurrentSiteUnknown, setCurrentSiteUnknown] = useState(false);

    async function loadURI() {
        const contract = new ethers.Contract(seedAddress, reBurnProtocol.abi, web3);
        const mainUri = await contract.uri();
        const uriset = await contract.metadata("uriset");
        if (uriset) {
            //schema is an array of uri/version objects : [{"uri": "...", "version": 1}, {"uri": "...", "version": 2}]
            const sites = JSON.parse(uriset);

            const matchCurrent = sites.filter(site => site.uri === current);
            if (matchCurrent.length === 0) {
                setCurrentSiteUnknown(true);
            }
            const betterVersions = sites.filter(site => site.version > currentversion);
            if (betterVersions.length > 0) {
                betterVersions.sort((a, b) => (a.version === b.version) ? 0 : (a.version > b.version ? -1 : +1));
                setRecommendedUri(betterVersions[0].uri);
                //TODO: if there's more than 1 better URI, pick one matching the protocol (if already on ipfs:// remain, otherwise suggest http)
            } else {
                //there's no *newer* version, but the current site may still be unknown
                setRecommendedUri(mainUri);
            }
        } else {
            //fallback to plain URI check
            if (mainUri && current !== mainUri) {
                setCurrentSiteUnknown(true);
                setRecommendedUri(mainUri);
            }
        }
    }

    if (!loading) {
        setLoading(true);
        loadURI();
    }

    return (
    <>
        {isCurrentSiteUnknown &&
            <div className="alert alert-warning" role="alert">
            The most recent official contract URI is <a href={recommendedUri}>{recommendedUri}</a>. Your location is {current}.
            You may be on an older or wrong version.
            </div>
        }
        </>
    );
}